import React from 'react';
import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';

// import ExpandingSearch from '../ExpandingSearch';

import {
  Wrapper,
  StyledContainer,
  Title,
  SubTitle,
  Social,
  Controls,
  StyledSelect,
  StyledSelectLabel,
} from './styles';

// * Our defaultOption for the filter select
const defaultOptions = [{ value: 'default', label: 'All' }];

const createSelectOptions = (value, label) => ({ value, label });

/*
 * title: {string} the title for the main blog page
 * subTitle: {string} the subtitle for the main blog page
 * searchText: {string} label for the search, that is passed to the search input
 * searchPlaceHolderText: {string} placeholder for the search that is passed to the search input
 * filterText: {string} placeholder label for filter dropdown
 * searchIcon: {img} icon for the search button
 * linkedInIcon {img} url of the icon for the social platform
 * linkedInLink {string} url to link to their social platform
 */

const BlogHeading = ({
  data,
  activeFilter,
  // activeFilterLabel,
  setActiveFilter,
}) => {
  if (!data) return null;
  const {
    title,
    subTitle,
    // searchText,
    // searchPlaceHolderText,
    filterText,
    searchIcon,
    socialShare,
    location,
    categoryFilter,
  } = data;

  // * Gets an array of categories and creates an array of { value, label } objs to pass into the select dropdown as options
  const filters = categoryFilter
    .filter(({ id }) => {
      return id !== 'prodigy-culture';
    })
    .map(({ id, text }) => createSelectOptions(id, text));

  // * Creates the options array by adding our defaultOption at the top, followed by all the other filters
  const options = [...defaultOptions, ...filters];

  return (
    <Wrapper className={activeFilter ? 'filter-active' : ''}>
      <StyledContainer className="auto-margin">
        <Title>{RichText.asText(title)}</Title>
        {subTitle && (
          <SubTitle className="h3">{RichText.asText(subTitle)}</SubTitle>
        )}
        {socialShare && <Social social={socialShare} location={location} />}
        {(filterText || searchIcon) && (
          /* eslint-disable */
          <label>
            <Controls>
              {filterText && (
                <StyledSelect
                  label=""
                  options={options}
                  defaultOption={options[0]}
                  state={activeFilter}
                  setState={setActiveFilter}
                />
              )}
              {
                <StyledSelectLabel
                  value={
                    activeFilter
                      ? `Topics: ${activeFilter.label}`
                      : 'Topics: All'
                  }
                >
                  {activeFilter
                    ? `Topics: ${activeFilter.label}`
                    : 'Topics: All'}
                </StyledSelectLabel>
              }
              {/* {searchIcon && (
              <ExpandingSearch
                label={searchText}
                placeholder={searchPlaceHolderText}
                icon={searchIcon}
              />
            )} */}
          </Controls>
          </label>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

BlogHeading.propTypes = {
  data: PropTypes.shape().isRequired,
  activeFilter: PropTypes.string,
  setActiveFilter: PropTypes.func.isRequired,
};

BlogHeading.defaultProps = {
  activeFilter: null,
};

export default BlogHeading;
